import { render, staticRenderFns } from "./SuperAdminMobileMenu.vue?vue&type=template&id=6c0bd6ee&"
import script from "./SuperAdminMobileMenu.vue?vue&type=script&lang=js&"
export * from "./SuperAdminMobileMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports